/**
 * Vuex actions for the "member" module (registered as `user`).
 *
 * User search/autocomplete and reputation-score history lookups used by
 * mention pickers and profile reputation charts.
 */
export default {
  /** Search users by `payload.query` (with autocomplete/limit options); no-ops on an empty query. */
  async fetchUsers({ commit }, payload) {
    if (!payload.query || payload.query === '') {
      return;
    }
    const params = new URLSearchParams({
      search: payload.query,
      limit: payload.limit,
      autocomplete: payload.autocomplete,
    }).toString();
    if (params !== '') {
      let response = await fetch(`/api/users?${params}`);
      let data = await response.json();
      commit('setUsersData', data);
      return data;
    }
  },
  /** Fetch a user's 30-day reputation rating history and commit it. */
  async getUserReputationScores({ commit }, userId) {
    const data = await fetch(`/api/users/${userId}/rating-history?days=30`, {
      credentials: "include",
    });
    const result = await data.json();
    commit('setUserReputationScores', result);
    return result;
  },
};
